(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function prepare(root = document) {
    for (const video of root.querySelectorAll('[data-ic-story-video]:not([data-bound])')) {
      video.dataset.bound = 'true';
      const button = video.closest('section').querySelector('[data-ic-video-toggle]');
      const play = async () => {
        const source = video.querySelector('source');
        if (!source.src) { source.src = source.dataset.src; video.load(); }
        try { await video.play(); } catch { /* Native autoplay refusal leaves the poster and Play control. */ }
      };
      const label = () => { button.textContent = video.paused ? 'Play video' : 'Pause video'; };
      video.addEventListener('play', label); video.addEventListener('pause', label);
      button.hidden = false;
      button.addEventListener('click', () => video.paused ? play() : video.pause());
      motion.addEventListener('change', event => { if (event.matches) video.pause(); });
      const autoplay = () => { if (!motion.matches && !navigator.connection?.saveData && video.isConnected) play(); };
      if (document.readyState === 'complete') autoplay();
      else window.addEventListener('load', autoplay, { once: true });
    }
  }
  prepare();
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ic-light-src]');
    if (!button) return;
    const card = button.closest('.ic-story-card');
    card.dataset.requestedLight = new URL(button.dataset.icLightSrc, document.baseURI).href;
    const preload = new Image(); preload.src = button.dataset.icLightSrc;
    try { await preload.decode(); } catch { return; }
    if (!card.isConnected || card.dataset.requestedLight !== preload.src) return;
    const image = card.querySelector('[data-ic-light-image]');
    image.src = preload.src; image.alt = button.dataset.icLightAlt;
    for (const control of card.querySelectorAll('[data-ic-light-src]')) control.setAttribute('aria-pressed', String(control === button));
  });
})();

